// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"a27181a0","257":"2fb106f0","606":"5ea3d0c3","992":"6cecd746"}[chunkId] + ".chunk.css";
};